module.exports = "\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /Users/pkovacs/Documents/Development/ngsAlpha/ngs_alpha_ui/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main